/**
 * API接口URL定义，格式： 模块名_功能名
 */
module.exports = {
    /**
     * 系统服务
     */
    SERVICE_MENU_LIST: '/service/menu-list', // 系统菜单列表
    SERVICE_GET_PICTURE_CAPTCHA: '/auth/captcha', // 获取图片验证码
    /**
     * 首页
     */
    HOME_INVOICE_STAT: '/home/invoice-stat', // 商户开票统计信息
    /**
     * 用户
     */
    USER_LOGIN: '/auth/login', // 用户登录
    USER_CHANGE_PASSWORD: '/user/password/reset', // 修改密码
    USER_REGISTER: '/developer/apply', // 用户注册
    USER_RESET: '/auth/reset', // 重置密码
    SERVICE_SEND_SMS_CAPTCHA: '/auth/vcode', // 获取手机验证码
    SERVICE_CHECK_SMS_CAPTCHA: '/auth/vcode/validate', // 验证手机验证码
    USER_INFO: '/user/profile', // 获取用户信息
    USER_INFO_UPDATE: '/developer/profile', // 修改用户信息
    // 应用管理
    GET_APP_LIST: '/app/list', // 应用列表
    CREATE_APP: '/app', // 创建应用
    UPDATE_APP: '/app/update', // 修改应用
    DELETE_APP: '/app/delete', // 删除应用
    GET_APP_INFO: '/app', // 获取应用详情
    GET_TEST_APP: '/developer/config', // 获取testAPPKey
    // 订单管理
    GET_ORDER_LIST: '/order/list', // 订单列表
    GET_PRODUCT_LIST: '/product/list', // 产品服务列表
    GET_PRODUCT_DIC: '/app/simple/list', // 产品字典
    GET_PRODUCT_DETAIL: '/product/detail', // 产品详情
    GET_PRODUCT_CHART: '/product/account/detail', // 产品报表
    GET_SERVICE_DIC: '/product/simple/list',
    GET_PRODUCT_API_LIST: '/product/api/list', // 获取服务api列表
    // 授权登录
    GET_APP_AUTH_CAPTCHA: '/auth/business/captcha', // 获取授权登录图片验证码
    POST_APP_AUTH_LOGIN: '/auth/business/login', // 应用授权登录

}
